var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#D6DDEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5285 16.7542C16.7429 14.6226 18.537 13 20.6793 13C22.8216 13 24.6157 14.6226 24.8302 16.7542L25.0435 18.8742C25.1509 19.9416 25.5197 20.9661 26.1173 21.857L26.766 22.8241C27.1238 23.3574 27.3027 23.6241 27.3377 23.8394C27.41 24.2838 27.1764 24.7216 26.7672 24.9091C26.5688 25 26.2477 25 25.6055 25H15.7532C15.1109 25 14.7898 25 14.5915 24.9091C14.1822 24.7216 13.9487 24.2838 14.0209 23.8394C14.056 23.6241 14.2349 23.3574 14.5926 22.8241L15.2413 21.857C15.8389 20.9661 16.2077 19.9416 16.3151 18.8742L16.5285 16.7542Z",
    fill: "#273B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2215 26.9721C19.3075 27.0518 19.4969 27.1223 19.7605 27.1725C20.0241 27.2228 20.347 27.25 20.6793 27.25C21.0115 27.25 21.3344 27.2228 21.598 27.1725C21.8616 27.1223 22.0511 27.0518 22.1371 26.9721",
    stroke: "#273B4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ae62839a729df8ea2877e033f4e4c395.svg";
export { ForwardRef as ReactComponent };